import type { Fact } from "~/components/inside/facts";
import * as m from "~/paraglide/messages.js";

/** The three facts the studio band states, in the order the design sets them. */
export function getStudioFacts(): Fact[] {
  return [
    {
      term: m.about_fact_based_term(),
      value: m.about_fact_based_value(),
    },
    {
      term: m.about_fact_focus_term(),
      value: m.about_fact_focus_value(),
    },
    {
      term: m.about_fact_start_term(),
      value: m.about_fact_start_value(),
    },
  ];
}

export interface Principle {
  body: string;
  title: string;
}

/**
 * What a client can expect, in the order an engagement meets them: the
 * questions before the work, the visibility during it, the support after.
 */
export function getPrinciples(): Principle[] {
  return [
    {
      body: m.about_principle_1_body(),
      title: m.about_principle_1_title(),
    },
    {
      body: m.about_principle_2_body(),
      title: m.about_principle_2_title(),
    },
    {
      body: m.about_principle_3_body(),
      title: m.about_principle_3_title(),
    },
  ];
}
